export default "__VITE_ASSET__Eu_qco1E__"